var render = function render(){var _vm=this,_c=_vm._self._c;return _c('cms-block',_vm._b({attrs:{"no-padding":""},on:{"block-selected":_vm.selectBlock}},'cms-block',_vm.$props,false),[_c('div',{staticClass:"spacer",style:(_vm.style)})])
}
var staticRenderFns = []

export { render, staticRenderFns }